import { render } from "./SellWalletDetails.vue?vue&type=template&id=5603214a&scoped=true&ts=true"
import script from "./SellWalletDetails.vue?vue&type=script&lang=ts"
export * from "./SellWalletDetails.vue?vue&type=script&lang=ts"

import "./SellWalletDetails.vue?vue&type=style&index=0&id=5603214a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5603214a"],['__file',"src/components/sell/SellWalletDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5603214a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5603214a', __exports__)) {
    api.reload('5603214a', __exports__)
  }
  
  module.hot.accept("./SellWalletDetails.vue?vue&type=template&id=5603214a&scoped=true&ts=true", () => {
    api.rerender('5603214a', render)
  })

}


export default __exports__